import React from "react";
import Header from "../../ComponentsWeb/Sub/Header";
import Footer from "../../ComponentsWeb/Sub/Footer";
import OrderDetails from "./OrderDetails";

function UserOrderReper() {
  return (
    <>
      <Header />
      <OrderDetails />
      <Footer />
    </>
  );
}

export default UserOrderReper;
